import { useEffect } from 'react'
import { setSalesCopilotOfferStay } from 'actions/AiOpsActions'
import { useAppDispatch } from 'hooks/reduxHooks'

// Offer pages keep their state in context below the app, so each one mirrors the agent's stay into redux for the sidebar.
function usePublishSalesCopilotStay(offerStay: App.SalesCopilotOfferStay | undefined) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setSalesCopilotOfferStay(offerStay))
  }, [dispatch, offerStay])
}

export default usePublishSalesCopilotStay
